"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HeightClip = exports.HeightClipDefaultProps = void 0;
var react_1 = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var cn_1 = require("../../utils/cn");
var theme_1 = require("@shapeable/theme");
var use_dimensions_1 = __importDefault(require("../../hooks/use-dimensions"));
var badge_divider_1 = require("./badge-divider");
var use_lang_1 = require("../../hooks/use-lang");
var cls = (0, cn_1.classNames)('height-clip');
exports.HeightClipDefaultProps = {
  maxHeight: 300,
  showFade: true
};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    position: relative;\n    overflow: hidden;\n\n    ", "\n\n  "], ["\n    position: relative;\n    overflow: hidden;\n\n    ", "\n\n  "])), function (_a) {
    var canExpand = _a.canExpand;
    return canExpand && (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      padding-bottom: ", ";\n    "], ["\n      padding-bottom: ", ";\n    "])), theme_1.theme.UNIT(10));
  })
});
var BodyStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    position: relative;\n  "], ["\n    position: relative;\n  "])))
});
var FadeStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    background: linear-gradient(to bottom, transparent 0%, rgba(255, 255, 255, 1.0) 50%, rgba(255, 255, 255, 1.0) 100%);\n    width: 100%;\n    position: absolute;\n    bottom: 0;\n    z-index: 40;\n  "], ["\n    background: linear-gradient(to bottom, transparent 0%, rgba(255, 255, 255, 1.0) 50%, rgba(255, 255, 255, 1.0) 100%);\n    width: 100%;\n    position: absolute;\n    bottom: 0;\n    z-index: 40;\n  "])))
});
var MoreButtonStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    position: absolute;\n    bottom: 0;\n    width: 100%;\n    z-index: 50;\n    cursor: pointer;\n\n    &:hover {\n      color: ", ";\n    }\n\n  "], ["\n    position: absolute;\n    bottom: 0;\n    width: 100%;\n    z-index: 50;\n    cursor: pointer;\n\n    &:hover {\n      color: ", ";\n    }\n\n  "])), theme_1.theme.COLOR('primary'))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Body: styled_components_1.default.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Fade: styled_components_1.default.span(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), FadeStyles),
  MoreButton: (0, styled_components_1.default)(badge_divider_1.BadgeDivider)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), MoreButtonStyles)
};
var HeightClip = function (props) {
  var className = props.className,
    children = props.children,
    onChange = props.onChange,
    maxHeight = props.maxHeight;
  var t = (0, use_lang_1.useLang)();
  var _a = __read((0, use_dimensions_1.default)(), 2),
    bodyRef = _a[0],
    bodyDimensions = _a[1];
  var _b = __read((0, use_dimensions_1.default)(), 2),
    containerRef = _b[0],
    containerDimensions = _b[1];
  var _c = __read((0, use_dimensions_1.default)(), 2),
    moreButtonRef = _c[0],
    moreButtonDimensions = _c[1];
  var bodyHeight = bodyDimensions && bodyDimensions.height || 0;
  var containerHeight = containerDimensions && containerDimensions.height || 0;
  var moreButtonHeight = moreButtonDimensions && moreButtonDimensions.height || 0;
  var _d = __read((0, react_1.useState)(true), 2),
    expanded = _d[0],
    setExpanded = _d[1];
  var _e = __read((0, react_1.useState)(false), 2),
    canExpand = _e[0],
    setCanExpand = _e[1];
  (0, react_1.useLayoutEffect)(function () {
    if (bodyHeight > maxHeight) {
      setExpanded(false);
      setCanExpand(true);
    }
  }, [bodyHeight]);
  var buttonOnClick = function (event) {
    event.stopPropagation();
    event.preventDefault();
    var newState = !expanded;
    setExpanded(newState);
    if (onChange) {
      onChange(newState);
    }
  };
  var containerStyle = !expanded ? {
    height: "".concat(maxHeight, "px"),
    paddingBottom: "".concat(moreButtonDimensions.height, "px")
  } : {};
  var fadeStyles = {
    height: "".concat(3 * moreButtonHeight, "px")
  };
  return react_1.default.createElement(My.Container, {
    canExpand: canExpand,
    style: containerStyle,
    ref: containerRef,
    className: className
  }, react_1.default.createElement(My.Body, {
    ref: bodyRef
  }, children), !expanded && react_1.default.createElement(My.Fade, {
    style: fadeStyles,
    className: cls.sub('fade')
  }), canExpand && react_1.default.createElement(My.MoreButton, {
    lineVariant: 'dotted',
    ref: moreButtonRef,
    onClick: buttonOnClick
  }, t(expanded ? 'Collapse' : 'Read More...')));
};
exports.HeightClip = HeightClip;
exports.HeightClip.cls = cls;
exports.HeightClip.defaultProps = exports.HeightClipDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;